import { FC, ReactNode } from 'react';
import Modal, { ModalButton } from 'components/Modal';
import { pdfjs } from 'react-pdf';
import { GenericFileViewer } from 'components/Files/FileViewer';
import styled from 'styled-components';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ImageMissingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  margin: 20px;
`;

interface Props {
  title?: string | ReactNode;
  fileEnding?: string;
  fileGuid?: string;
  maxHeight?: number;
  onClose(): void;
  buttons?: ModalButton[];
  description?: string;
}

const GenericFileViewerModal: FC<Props> = ({
  title,
  fileEnding,
  fileGuid,
  onClose,
  buttons,
  maxHeight,
  description,
}) => {
  return (
    <Modal
      buttons={[{ label: 'Stäng', onClick: onClose }, ...(buttons || [])]}
      onClose={onClose}
      title={title}
    >
      <Wrapper>
        {fileGuid && fileEnding ? (
          <GenericFileViewer
            browsable
            fileEnding={fileEnding}
            fileGuid={fileGuid}
            maxHeight={maxHeight}
          />
        ) : (
          <ImageMissingWrapper>Bild saknas</ImageMissingWrapper>
        )}
        {description && <pre>{description}</pre>}
      </Wrapper>
    </Modal>
  );
};

export default GenericFileViewerModal;
